// material
import { Grid, Container, Tabs, Tab } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllFeedsByOrg } from '../service/feed.service';
import { getClassOverview } from '../service/states.service';
// components
import Page from '../components/Page';
import {
  // AppTasks,
  TotalClasses,
  AppNoOfTestsReports,
  TeacherBoard,
  AppWeeklySales
} from '../components/_dashboard/app';
import EmptyDashboard from '../components/EmptyDashboard';
import EmptyDashboardChart from '../components/EmptyDashboardChart';
import TeacherDashboardFeeds from './Teacher/Insights/TeacherFeed';
import { ADD_INSIGHTS, SET_ORG_FEEDS } from '../redux/constants';
import { SkeletonDashboardFeed } from '../fl-components/skeleton/SkeletonDashboardFeed';

// ----------------------------------------------------------------------

export default function DashboardApp() {
  const orgStates = useSelector((state) => state.insights.data);
  const feedList = useSelector((state) => state.feeds.orgFeeds);
  const [isLoading, setIsLoading] = useState(feedList === null);
  const feedOffset = useSelector((state) => state.feeds.orgFeedOffset);
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    async function fetchFeedList() {
      const res = await getAllFeedsByOrg(selectedOrg?.id ?? selectedOrg?.orgId, feedOffset);
      if (res) {
        dispatch({
          type: SET_ORG_FEEDS,
          payload: {
            feeds: res.results,
            offset: feedOffset + 1
          }
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    }

    async function getClass() {
      if (selectedOrg?.orgId) {
        const res = await getClassOverview(selectedOrg?.id ?? selectedOrg?.orgId);
        if (res) {
          dispatch({ type: ADD_INSIGHTS, payload: res });
        }
      }
      // TODO: This is work around for when we don't have orgID then this will terminate the isLoading after 4sec.
      setTimeout(() => {
        setIsLoading(false);
      }, 4000);
    }
    if (orgStates === null) getClass();
    if (feedList === null) fetchFeedList();
  }, [selectedOrg?.id ?? selectedOrg?.orgId]);

  return (
    <Page title="Dashboard">
      {isLoading ? (
        <SkeletonDashboardFeed />
      ) : (
        <Container>
          <Tabs
            value={currentTab}
            onChange={(event, newValue) => setCurrentTab(newValue)}
            variant="scrollable"
            scrollButtons={false}
            aria-label="scrollable prevent tabs example"
            sx={{ mb: 2 }}
          >
            <Tab label="Feeds" />
            <Tab label="Insights" />
          </Tabs>
          {currentTab === 0 && <TeacherDashboardFeeds />}
          {currentTab === 1 &&
            (Object.keys(orgStates).length > 0 ? (
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                  <AppWeeklySales value={orgStates?.totalStudents} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TotalClasses value={orgStates?.totalClasses} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TeacherBoard value={orgStates?.totalHours} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <AppNoOfTestsReports value={orgStates?.totalTests} />
                </Grid>

                <EmptyDashboardChart />
              </Grid>
            ) : (
              <EmptyDashboard />
            ))}
        </Container>
      )}
    </Page>
  );
}
